// Employee Management Constants
export const DESIGNATION_CHOICES = [
  { value: 'BD Head', label: 'BD Head' },
  { value: 'AR Head', label: 'AR Head' },
  { value: 'Coder (CPT)', label: 'Coder (CPT)' },
  { value: 'AR Executive', label: 'AR Executive' },
  { value: 'Credentialing Specialist', label: 'Credentialing Specialist' },
  { value: 'AR Specialist', label: 'AR Specialist' },
  { value: 'BD Executive', label: 'BD Executive' },
  { value: 'BD Officer', label: 'BD Officer' },
  { value: 'Billing Executive', label: 'Billing Executive' },
  { value: 'Billing Specialist', label: 'Billing Specialist' },
  { value: 'Coder', label: 'Coder' },
  { value: 'Remote Working', label: 'Remote Working' },
  { value: 'Python Intern', label: 'Python Intern' },
  { value: 'Internal Auditor', label: 'Internal Auditor' },
  { value: 'Director', label: 'Director' },
  { value: 'HR Manager', label: 'HR Manager' },
  { value: 'Administrator', label: 'Administrator' },
  { value: 'Office Boy', label: 'Office Boy' },
  { value: 'Cleaning Maid', label: 'Cleaning Maid' },
  { value: 'Eligibility Specialist', label: 'Eligibility Specialist' },
  { value: 'AR Intern', label: 'AR Intern' },
  { value: 'Billing Intern', label: 'Billing Intern' },
  { value: 'Authorization Specialist', label: 'Authorization Specialist' },
  { value: 'Team Lead AR', label: 'Team Lead AR' },
  { value: 'Team Lead Billing', label: 'Team Lead Billing' },
  { value: 'Other', label: 'Other' },
];

export const DEPARTMENT_CHOICES = [
  { value: 'Billing', label: 'Billing' },
  { value: 'AR', label: 'AR' },
  { value: 'Authorization', label: 'Authorization' },
  { value: 'Business Development', label: 'Business Development' },
  { value: 'Credentialing', label: 'Credentialing' },
  { value: 'HR', label: 'HR' },
  { value: 'Domestic', label: 'Domestic' },
  { value: 'Technical', label: 'Technical' },
  { value: 'Technical Remote', label: 'Technical Remote' },
  { value: 'Management', label: 'Management' },
  { value: 'Other', label: 'Other' },
];

export const CURRENCY_CHOICES = [
  { value: 'PKR', label: 'PKR' },
  { value: 'USD', label: 'USD' },
  { value: 'AED', label: 'AED' },
  { value: 'EUR', label: 'EUR' },
  { value: 'GBP', label: 'GBP' },
];

export const STATUS_CHOICES = [
  { value: 'All', label: 'All Status' },
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
];

export const TABLE_HEAD = [
  { id: 'full_name', label: 'Employee Name', alignRight: false, sortable: true },
  { id: 'designation', label: 'Designation', alignRight: false, sortable: true },
  { id: 'department', label: 'Department', alignRight: false, sortable: true },
  { id: 'shift', label: 'Shift', alignRight: false, sortable: false },
  { id: 'email', label: 'Email', alignRight: false, sortable: false },
  { id: 'phone', label: 'Phone', alignRight: false, sortable: false },
  { id: 'user_account', label: 'User Account', alignRight: false, sortable: false },
  { id: 'status', label: 'Status', alignRight: false, sortable: true },
  { id: 'actions', label: 'Actions', alignRight: false, sortable: false },
];
